const CamaraIcon = () => {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.12416 21.5749H23.4583C24.8557 21.5749 26 20.406 26 18.9786V7.29538C26 5.868 24.8557 4.6991 23.4583 4.6991H20.4076C19.9882 4.6991 19.5363 4.36707 19.405 3.96003L18.6159 1.54347C18.4829 1.13672 18.0322 0.804688 17.6128 0.804688H8.96965C8.55026 0.804688 8.09839 1.13672 7.96678 1.54376L7.1777 3.96032C7.04497 4.36736 6.59451 4.69939 6.17512 4.69939H3.12416C1.72676 4.69939 0.582397 5.86829 0.582397 7.29567V18.9786C0.582397 20.406 1.72676 21.5749 3.12416 21.5749Z"
        fill="white"
      />
      <circle
        cx="13.316"
        cy="12.3714"
        r="5.12531"
        stroke="#FF6600"
        strokeWidth="3"
      />
      <circle cx="23.7411" cy="7.7849" r="1.01928" fill="#FF6600" />
    </svg>
  );
};

export default CamaraIcon;
